import React from 'react';
import styled, { keyframes, StyledComponentClass } from 'styled-components';
import c from 'classnames';
import { colors, globals } from '../../styles';
import { CheckboxProps } from './props';
import checkMark from '../../assets/icons/checkmark-white.svg';

class CheckBox extends React.Component<CheckboxProps, any> {
  public static defaultProps: Partial<CheckboxProps> = {
    size: 'md',
  };

  render() {
    const {
      className,
      defaultChecked,
      disabled,
      id,
      name,
      onChange,
      size,
      checked,
    } = this.props;

    return (
      <input
        className={c(className, size, { disabled })}
        defaultChecked={defaultChecked}
        disabled={disabled}
        id={id}
        checked={checked}
        name={name}
        onChange={onChange}
        type="checkbox"
      />
    );
  }
}

const bounce = keyframes`
  0% {
    transform: scale(1);
  }
  33% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;

const StyledCheckBox = styled(CheckBox)`
  ${globals.input};
  box-shadow: 0 0 0 2px ${colors.grey700};
  cursor: pointer;

  &.disabled {
    opacity: 0.3;
    cursor: default;
  }

  &:hover {
    background-color: ${colors.green10};
    box-shadow: 0 0 0 2px ${colors.green300};
  }
  &:checked {
    background: url(${checkMark}) center center no-repeat;
    background-color: ${colors.brand};
    background-size: 90%;
    box-shadow: 0 0 0 2px ${colors.brand};
    animation: ${bounce} 300ms;
  }

  &.xs {
    min-width: 11px;
    height: 11px;
  }
  &.sm {
    min-width: 13px;
    height: 13px;
  }
  &.md {
    width: 15px;
    height: 15px;
  }
  &.lg {
    min-width: 19px;
    height: 19px;
  }
  &.xl {
    min-width: 22px;
    height: 22px;
  }
`;

export default StyledCheckBox;
